import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path: '/site',
        name: 'indexSite',
        alias: ['/site/inicio', '/site/index'],
        component: () => import('../views/Site'),
        meta: {
            public: true
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.addRoutes(routes)
export default router
